var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"flex justify-center pl-4 sm:px-6 lg:px-0"},[_c('Gallery',{attrs:{"id":_vm.anchorName,"headline":_vm.headline,"elements":_vm.elements,"lightbox":_vm.lightbox}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }